import { useRef } from "react";
import { clamp, FONT } from "@/lib/photoEdit";

export const TextItem = ({ t, box, interactive, onTap, onDragStart, onMove }) => {
  const start = useRef(null);
  const down = (e) => {
    if (!interactive) return;
    e.stopPropagation();
    e.currentTarget.setPointerCapture(e.pointerId);
    start.current = { x: e.clientX, y: e.clientY, tx: t.x, ty: t.y, moved: false };
  };
  const move = (e) => {
    const s = start.current;
    if (!s) return;
    const dx = e.clientX - s.x, dy = e.clientY - s.y;
    if (!s.moved && Math.hypot(dx, dy) < 6) return;
    if (!s.moved) { s.moved = true; onDragStart(); }
    onMove(t.id, clamp(s.tx + dx / box.w), clamp(s.ty + dy / box.h));
  };
  const up = () => {
    const s = start.current;
    start.current = null;
    if (s && !s.moved) onTap(t);
  };
  return (
    <div data-testid={`photo-text-item-${t.id}`} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={() => { start.current = null; }}
      style={{ left: `${t.x * 100}%`, top: `${t.y * 100}%`, fontSize: t.size * box.w, color: t.color, fontFamily: FONT, pointerEvents: interactive ? "auto" : "none" }}
      className="absolute -translate-x-1/2 -translate-y-1/2 whitespace-pre text-center font-bold leading-[1.2] select-none touch-none cursor-move [text-shadow:0_1px_4px_rgba(0,0,0,0.6)]">
      {t.text}
    </div>
  );
};
